/*
  Brief Tabs Controller

  Activates tabs for an activity brief page

  EMITTED EVENTS
    brief-updated (document) Emitted after the brief has been successfully updated so listeners can take action if needed
      detail: {
        el: the root element of this controller instance
      }
*/

import BriefTabsController from './brief-tabs-controller';

export default class extends BriefTabsController {

  repaintTabs(newTab) {
    super.repaintTabs(newTab);
    this.scrollTabContainerToActiveTab();
  }

  scrollTabContainerToActiveTab() {
    this.activeTab.parentNode.scrollLeft += this.activeTab.getBoundingClientRect().left;
  }

  //
  // GETTERS AND SETTERS
  //

  get activeTab() {
    return [...this.tabItemTargets].find((item) => item.classList.contains('active'));
  }
};



// WEBPACK FOOTER //
// ./app/components/briefs/assets/javascript/mobile-brief-tabs-controller.js